import { getDefaultZoomUI } from './zoomUI';
import { completeObject } from '../../Shared/complete';
export function isTokenTemplateName(name) {
    return /^{.*}$/.test(`${name}`);
}
export function getValue(source, token, defaultValue) {
    try {
        if (typeof token === 'string' && isTokenTemplateName(token)) {
            const path = token.replace(/^{|}$/g, '');
            const keyList = path.replace(/\[(\d+)\]/g, '.$1').split('.');
            const result = keyList.reduce((obj, key) => Object(obj)[key], source);
            if (typeof result === 'number' || typeof result === 'string') {
                return result;
            }
            return defaultValue;
        }
    }
    catch (err) {
        // eslint-disable-next-line no-console
        console.warn(err);
    }
    return undefined;
}
export function getThemeOptions(mode, customZoomUI) {
    const defaultZoomUI = getDefaultZoomUI();
    return {
        palette: {
            mode,
        },
        typography: {
            fontFamily: defaultZoomUI.typography.fontFamily,
            fontSize: 14,
        },
        // Zoom UI Custom Theme
        zoomUI: completeObject(customZoomUI ?? {}, defaultZoomUI),
    };
}
export function generateThemeToken(opts) {
    const { componentName, theme, themeToken } = opts;
    const token = themeToken;
    let targetToken = token.light;
    if (theme?.palette?.mode === 'dark') {
        targetToken = completeObject(token.dark, token.light);
    }
    if (theme?.zoomUI?.componentTokens?.[componentName]) {
        if (theme?.palette?.mode === 'dark') {
            targetToken = completeObject(theme?.zoomUI?.componentTokens?.[componentName]?.dark, targetToken);
        }
        else {
            targetToken = completeObject(theme?.zoomUI?.componentTokens?.[componentName]?.light, targetToken);
        }
    }
    const zoomUI = theme?.zoomUI || getThemeOptions(theme?.palette?.mode)?.zoomUI;
    function getTokenValue(tokenName) {
        if (isTokenTemplateName(tokenName)) {
            const value = getValue(zoomUI, tokenName);
            return value;
        }
        return tokenName;
    }
    return [targetToken, getTokenValue];
}
export function generateDynamicThemeToken(opts) {
    const { componentName, theme, dynamicToken } = opts;
    let targetToken = dynamicToken;
    if (theme?.zoomUI?.componentTokens?.[componentName]) {
        if (theme?.palette?.mode === 'dark') {
            targetToken = completeObject(theme?.zoomUI?.componentTokens?.[componentName]?.dark, targetToken);
        }
        else {
            targetToken = completeObject(theme?.zoomUI?.componentTokens?.[componentName]?.light, targetToken);
        }
    }
    const zoomUI = theme?.zoomUI || getThemeOptions(theme?.palette?.mode)?.zoomUI;
    function getTokenValue(tokenName) {
        if (isTokenTemplateName(tokenName)) {
            const value = getValue(zoomUI, tokenName);
            return value;
        }
        return tokenName;
    }
    return [targetToken, getTokenValue];
}
